<template>
  <div class="element-section">
    <!-- Section Header -->
    <div class="section-header" @click="toggleExpanded">
      <span class="section-title">{{ title }}</span>
      <div class="section-divider"></div>
      <button class="section-toggle" :class="{ collapsed: !isExpanded }">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
          <path d="M0 7L1.41 8.41L7 2.83L12.59 8.41L14 7L7 0L0 7Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <!-- Section Content -->
    <div class="section-content" v-show="isExpanded">
      <ElementItem
        v-for="element in elements"
        :key="element.type"
        :type="element.type"
        :label="element.label"
        :icon-svg="element.iconSvg"
        :disabled="disabled"
        @drag-start="handleElementDragStart"
        @drag-end="handleElementDragEnd"
      />
    </div>
  </div>
</template>

<script>
import ElementItem from './ElementItem.vue';

export default {
  name: 'ElementSection',
  components: {
    ElementItem
  },
  props: {
    title: {
      type: String,
      required: true
    },
    elements: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultExpanded: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['element-drag-start', 'element-drag-end'],
  data() {
    return {
      isExpanded: this.defaultExpanded
    };
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    handleElementDragStart(element) {
      this.$emit('element-drag-start', element);
    },
    handleElementDragEnd() {
      this.$emit('element-drag-end');
    }
  }
};
</script>

<style scoped>
.element-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  background: #fff;
}

.section-title {
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  flex-shrink: 0;
}

.section-divider {
  flex: 1;
  height: 1px;
  background: #C4C4C4;
  min-width: 20px;
}

.section-toggle {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:rgba(232, 244, 253, 0.50);
  border: none;
  border-radius: 12px;
  color: #374957;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.section-toggle:hover {
  background: #1E4670;
  color: #fff;
}

.section-toggle svg {
  transition: transform 0.2s ease;
}

.section-toggle.collapsed svg {
  transform: rotate(-180deg);
}

.section-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
